module.exports = __webpack_public_path__ + "static/media/arrow-up.dedcd2f4.svg";